// extracted by mini-css-extract-plugin
export default {"counterexample":"d4ae12499016707c5214","multicounters":"ff7a41b4d43ea44aa743"};